import {
  Contact,
  Layout,
  MacBookWindow,
} from '@rumblefish/ui/Rumblefish23Theme';

import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { aiKnowledgeManagementSolutionsSeo } from './AiKnowledgeManagementSolutions.seo';
import { AiKnowledgeManagementSolutionsProps } from './AiKnowledgeManagementSolutions.types';
import { CostOfInformationChaos } from './CostOfInformationChaos';
import { SearchDatabase } from './SearchDatabase';
import { InstantKnowledge } from './InstantKnowledge';
import { scrollToElement } from '../../utils/handleScroll';
import { aiKnowledgeManagementSolutionsContactFormId } from './AiKnowledgeManagementSolutions.constants';
import { WhyChoose } from './WhyChoose';
import { Faq } from './Faq';
import { ContactTitle } from '@rumblefish/ui/src/components/Rumblefish23Theme/Contact/styles';
import { HowRagWorks } from './HowRagWorks';
import { OurWork } from './OurWork';

export const AiKnowledgeManagementSolutionsPage = ({
  blogPosts,
  caseStudies,
}: AiKnowledgeManagementSolutionsProps) => {
  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...aiKnowledgeManagementSolutionsSeo} />

      <MacBookWindow
        title={<>Enterprise AI Knowledge Management Solutions</>}
        description={
          <>
            Custom <b>AI Solutions</b> That Transform Scattered Knowledge into
            Strategic Intelligence
          </>
        }
        buttonText="Transform Your Enterprise Knowledge!"
        gradient="aqua"
        buttonLink="/contact"
        buttonHandleOnClick={() =>
          scrollToElement(aiKnowledgeManagementSolutionsContactFormId)
        }
      />

      <CostOfInformationChaos />

      <SearchDatabase />

      <InstantKnowledge />

      <WhyChoose />

      <HowRagWorks />

      <OurWork caseStudies={caseStudies} />

      <Faq />

      <Contact
        color="blue"
        title="Your Enterprise Deserves Better Than Generic Platforms"
        id={aiKnowledgeManagementSolutionsContactFormId}
        titleComponent={
          <>
            <ContactTitle variant="display_sm">
              Your Enterprise Deserves Better Than Generic Platforms
            </ContactTitle>
          </>
        }
        subtitle="Contact our team to discuss your business case and explore how AI solutions could enhance it"
      />
    </Layout>
  );
};
